<template>
    <div>
        <!-- ECharts图表容器 -->
        <div ref="FunnelChart" style="width: 100%; height: 300px;"></div>
    </div>
</template>
  
<script>
import ClueService from "~/services/SaleClues";
import echarts from 'echarts';

export default {
    props:{
        params:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            count_data: {
                categories: [],
                data: [],
            },
        };
    },
    created(){
        this.getData(this.searcherModel);
    },
    mounted() {
    },
    methods: {
        getData() {
            ClueService.getConvCountFunnel(this.params)
            .then(res=>{
                this.count_data = res.data;
                this.initChart();
            })
        },
        initChart() {
            const chartContainer = this.$refs.FunnelChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);

            const options = {
                // title: {
                //     text: '线索转化分析'
                // },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}%'
                },
                toolbox: {
                    feature: {
                        dataView: { readOnly: false },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['线索数量', '已跟进线索数', '关联客户线索数', '关联试用订单线索数', '关联正式订单线索数']
                },
                color: ['#66b1ff', '#85ce61', '#f78989', '#f6b777'],
                series: [
                    {
                        name: '线索转化分析',
                        type: 'funnel',
                        left: '25%',
                        top: 30,
                        bottom: 30,
                        width: '50%',
                        min: 0,
                        max: 100,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: 'none',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'right',
                            formatter: function(params) {
                                // params.name 代表名称，params.value 代表数值
                                // 使用toFixed(0)将数值转换为整数形式，并添加自定义后缀
                                return params.name + ' : ' + params.value;
                            }
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{a} <br/>{b} : {c}'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                            width: 1,
                            type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        // emphasis: {
                        //     label: {
                        //         show: false, // 取消鼠标聚焦时的标签显示
                        //     },
                        // },
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: this.count_data,
                    }
                ]
            };

            myChart.setOption(options);
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/clue/echarts/FunnelChart.vue